import { PaymentTableRecord } from '@mews-commander/data-access';
import { Dash, TooltippedTag } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { getTagVariantFromPaymentState, paymentStatusTextKeyMap } from './utils';

export const PaymentsTableStatusCell = ({
    state,
    transactionDetails,
}: Pick<PaymentTableRecord, 'state' | 'transactionDetails'>) => {
    if (!state) {
        return <Dash />;
    }

    return (
        <TooltippedTag variant={getTagVariantFromPaymentState[state]} tooltip={transactionDetails} outline>
            {lt(paymentStatusTextKeyMap[state])}
        </TooltippedTag>
    );
};
